<script>
  import SettingsCard from '../shared/SettingsCard.svelte';
  import SettingField from '../shared/SettingField.svelte';

  export let form;

  const inputClass =
    'h-11 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 shadow-sm outline-none transition placeholder:text-slate-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500';
</script>

<SettingsCard title="Profile Information" description="Basic account details used across the application.">
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
    <SettingField id="profile-name" label="Full Name">
      <input id="profile-name" bind:value={form.name} class={inputClass} />
    </SettingField>

    <SettingField id="profile-email" label="Email">
      <input id="profile-email" bind:value={form.email} disabled class={inputClass} />
    </SettingField>

    <SettingField id="profile-provider" label="Provider" className="md:col-span-2">
      <input id="profile-provider" readonly bind:value={form.provider} class={inputClass} />
    </SettingField>
  </div>
</SettingsCard>
